// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* dev/116 — the remedy action a failed data-loading node offers. */
.noHMvz7hciSNHJGcRc5y {
    font-size: 0.76rem;
    font-weight: 600;
    border-radius: 8px;
    padding: 4px 12px;
    cursor: pointer;
    border: 1px solid var(--curio-border-strong);
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
}

.noHMvz7hciSNHJGcRc5y:hover {
    border-color: var(--curio-text-secondary);
}

.WTJJqFSGAHaQwt46IEJe {
    font-size: 0.74rem;
    color: var(--curio-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/connectionKeys/AddKeyAction.module.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,4CAA4C;IAC5C,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;AACtC","sourcesContent":["/* dev/116 — the remedy action a failed data-loading node offers. */\n.button {\n    font-size: 0.76rem;\n    font-weight: 600;\n    border-radius: 8px;\n    padding: 4px 12px;\n    cursor: pointer;\n    border: 1px solid var(--curio-border-strong);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n}\n\n.button:hover {\n    border-color: var(--curio-text-secondary);\n}\n\n.note {\n    font-size: 0.74rem;\n    color: var(--curio-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `noHMvz7hciSNHJGcRc5y`,
	"note": `WTJJqFSGAHaQwt46IEJe`
};
export default ___CSS_LOADER_EXPORT___;
